import React from 'react';  
  
const ErrorMessage = ({ message, onRetry }) => {  
  return (  
    <div className="error-message">  
      <span>⚠️</span>  
      <div style={{ flex: 1 }}>  
        <p style={{ margin: 0 }}>{message}</p>  
        {onRetry && (  
          <button  
            className="btn btn-small btn-secondary"  
            onClick={onRetry}  
            style={{ marginTop: '10px' }}  
          >  
            Retry  
          </button>  
        )}  
      </div>  
    </div>  
  );  
};  
  
export default ErrorMessage;  

